import { fixScriptsSoTheyAreExecuted, replaceTokensInLink } from '../Utils/utils';
import {
  fbPixelFor528,
  globalSiteTagForm,
  outbrain,
  presellClickConversion,
  snapAndFBPixelsSpecificAff, snapSpecificPixel1850,
  taboola,
  tyConversionTag,
  visualOptimizerPixel,
} from './pixelsCode';

// const excludedPushnamiAffiliatesEasy = ['573'];

const includedTaboolaAffiliates = ['5050'];

export const placePixelInHead = (pixel, props = {}, replaceTokens = false) => {
  const frag = new DOMParser().parseFromString(replaceTokens ? replaceTokensInLink(pixel, props) : pixel, 'text/html');
  const scripts = fixScriptsSoTheyAreExecuted(frag);
  scripts.forEach((scriptPixel) => document.getElementsByTagName('head')[0].appendChild(scriptPixel));
};

// add affid to args if we want to add this back
export const placePushnami = () => {
  // if(!(window.location.hostname.indexOf('easyautosavings') >=0)  || !(excludedPushnamiAffiliatesEasy.indexOf(affid) >=0) ) {
  //   placePixelInHead(pushnami);
  // }
};

export const placeTaboola = (affid) => {
  if (includedTaboolaAffiliates.indexOf(affid) >= 0) {
    placePixelInHead(taboola);
  }
};

export const placeOutbrain = () => {
  placePixelInHead(outbrain);
};

export const placeVisualOptimizer = () => {
  placePixelInHead(visualOptimizerPixel);
};

export const placeSpecificFBPixel = () => {
  placePixelInHead(fbPixelFor528);
};

export const placeSpecificSnapAndFBPixels = () => {
  placePixelInHead(snapAndFBPixelsSpecificAff);
};

export const executePresellClickConversion = () => {
  placePixelInHead(presellClickConversion);
};

export const placeTYConversionTag = () => {
  placePixelInHead(tyConversionTag);
};

export const placeGlobalSiteTag = (step, updateAppState = false) => {
  const code = globalSiteTagForm;
  placePixelInHead(code);
  return !!updateAppState && updateAppState('gtagPlace', true);
};

export const executeSpecificSnap1850 = (props) => {
  const { affid } = props;
  if (affid.toString() === '1850') {
    placePixelInHead(snapSpecificPixel1850);
  }
};
